module.exports = "pegasus/assets/preview-16.png";